import React, { Component } from 'react';
import Consultar from './Components/Consultar';

import './Styles/App.css';

class App extends Component {

  render() {
    return (
      <div className='container'>
        <div className="row mt-5">
          <div className="col-xs-12 col-sm-12 col-md-3">
            <p></p>
          </div>
          <div className="col-xs-12 col-sm-12 mt-0 col-md-6">
            <img src='./logo.png' height="200" className="mb-5 img-fluid" />
            <Consultar />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-3">
            <p></p>
          </div>
        </div>
      </div>
    );
  }

}
export default App;
